import { useEffect, useState } from 'react'

const ONBOARDING_STORAGE_KEY = 'design-studio-onboarding-completed'

export const useOnboardingTour = () => {
  const [shouldShowTour, setShouldShowTour] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Check if tour has been completed before
    const hasCompletedTour = localStorage.getItem(ONBOARDING_STORAGE_KEY) === 'true'
    setShouldShowTour(!hasCompletedTour)
    setIsLoading(false)
  }, [])

  const markTourCompleted = () => {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true')
    setShouldShowTour(false)
  }

  const resetTour = () => {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY)
    setShouldShowTour(true)
  }

  const startTour = () => {
    setShouldShowTour(true)
  }

  return {
    shouldShowTour: !isLoading && shouldShowTour,
    markTourCompleted,
    resetTour,
    startTour,
    isLoading,
  }
}
